import {
  TableCellText,
} from "@ceridianhcm/components";
import { FormatCurrency } from "../../../../common/formatting";

export const PayFileRemittanceColumnsDefinitions = () => {
  return [
    {
      field: "taxType",
      label: "Tax Type",
      cellTemplate: (cellContext: any) => (
        <TableCellText>
          <div title={cellContext.rowData.taxType}>
            {cellContext.rowData.taxType}
          </div>
        </TableCellText>
      ),
    },
    {
      field: "taxNumber",
      label: "Tax Number",
      cellTemplate: (cellContext: any) => (
        <TableCellText>
          <div title={cellContext.rowData.taxNumber}>
            {cellContext.rowData.taxNumber}
          </div>
        </TableCellText>
      ),
    },
    {
      field: "amount",
      label: "Amount",
      cellTemplate: (cellContext: any) => (
        <TableCellText>
          <div title={cellContext.rowData.amount}>
            {FormatCurrency(cellContext.rowData.amount)}
          </div>
        </TableCellText>
      ),
    }
  ];
};
